import ApiGateway from '../aws/api-gateway/ApiGateway';
const debug = process.env.REACT_APP_DEBUG && false;
const apiRef = 'SystemManagementApi';
const broadcastMessage = async (input) => {
    let response = { err: null, data: null };
    try {
        response = await ApiGateway.post('/system/Notification/broadcastMessage', input, apiRef);
    }
    catch (e) {
        response.err = e;
    }
    return response;
};
/**
 * **Notification DAO**
 */
export const NotificationDAO = {
    broadcastMessage,
};
